<template>
    <div>
      <modal size="medium">
        <div slot="header">
            <div class="row columns">
              <h3>Ajout / Suppression de trésorerie :</h3>
            </div>
            <div class="row columns">
            </div>
        </div>
        <div slot="body">
            <div class="note text-centered">Choisissez le type de modification, ajout ou supprresion, saisissez un montant et validez</div>
            <br>
            <div class="row columns">
              <div class="large-6 large-centered">
                <select name="" id="" v-model="operationType">
                  <option value="+1">Ajout</option>
                  <option value="-1">Suppression</option>
                </select>
              </div>
              <div class="large-6 large-centered">
                <input type="number" min="0" step="10000" v-model="amount">
              </div>
            </div>
        </div>
        <div slot="footer" class="panel-footer" >
            <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2" @click="validate()"> valider</button>
            </div>
            <br>
        </div>
      </modal>
      <messageModal v-if="showCreatedModal" message="Le changement de trésorerie a été enregistrées !" @closeMessage="closeModals()"></messageModal>
    </div>
</template>
<script>
import modal from '../../common/modal.vue'
import teamExtraWinning from '../../../api/extra-winnings.api'
import messageModal from '../../common/message-modal.vue'

export default {
  name: 'playerCustomizeStatsModal',
  components: {
    modal,
    messageModal
  },
  props: {
    'teamId': Number
  },
  data () {
    return {
      amount: 0,
      operationType: '+1',
      showCreatedModal: false
    }
  },
  methods: {
    validate () {
      let extraWinnings = {}
      extraWinnings.created_by = this.$store.getters.currentUser.id
      extraWinnings.amount = this.amount * this.operationType / 1000
      extraWinnings.team = this.teamId
      teamExtraWinning.api.createExtraWinnings(extraWinnings)
      .then(response => {
        this.showCreatedModal = true
        this.$store.dispatch('reloadDetailedTeam')
      },
      error => {
        console.log('erreur impossible to create extra winnings')
        console.log(error)
      })
    },
    closeModals () {
      this.showCreatedModal = false
      this.$emit('closeMessage')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

.large-btn-icon {
  font-size: 0.8rem;
}

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.note {
  font-size: 0.8rem;
  margin-bottom: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// add-treasury-modal.vue?532b95ea